import { render, staticRenderFns } from "./Administrators.vue?vue&type=template&id=8311feb6&"
import script from "./Administrators.vue?vue&type=script&lang=ts&"
export * from "./Administrators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports